<!-- eslint-disable vue/no-duplicate-attributes -->
<template>
  <div>
    <v-main>
      <v-dialog
        v-model="dialogChangeExpire"
        style="border-radius: 0px !important"
        width="300"
      >
        <v-date-picker
          v-model="pickerChangeExpire"
          style="border-radius: 0px !important"
          color="rgb(28 67 124)"
          locale="th-th"
        ></v-date-picker>
        <div>
          <v-btn
            color="green"
            block
            style="color: white !important"
            @click="changExpirePackage()"
            ><v-icon>mdi-calendar-clock</v-icon>เปลี่ยนวันหมดอายุ</v-btn
          >
        </div>
      </v-dialog>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col>
            <h2>เพิ่มคะแนน</h2>
          </v-col>
          <v-col class="text-right" v-if="showTabel === true">
            <v-btn style="background-color: #1b437c !important">
              <v-icon left style="color: white !important">mdi-download</v-icon>
              <download-excel
                class="btn btn-default text-white"
                :data="export_data"
                :fetch="fetchExportData"
                :fields="export_field"
                :type="exportType"
                :worksheet="exportWorksheet"
                :name="exportFileName"
              >
                Export Data
              </download-excel>
            </v-btn>
            <!-- <v-btn style="background-color: #1b437c !important" class="btn btn-default text-white" v-if="$session.getAll().data.shopId === this.shopNameData.SHOP_ID_CHUBB" @click="dialogImport = true,getDataLevel()">
              <v-icon class="mr-3">mdi-file-account</v-icon>นำเข้าข้อมูลสมาชิก
            </v-btn> -->
          </v-col>
        </v-row>
        <div v-if="showTabel === true">
          <v-container>
            <v-row>
              <v-col>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date1"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateRangeText"
                      label="ค้นหาตามวันเกิด"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      dense
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      @click:clear="clearTextField()"
                      hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date1" no-title scrollable range>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="$refs.menu.save(date1)"> OK </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col>
                <v-select
                  :items='dataLevel'
                  v-model="searchlevel"
                  label="ระดับสมาชิก"
                  dense
                  outlined
                  hide-details
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-select

                :items=dataExchange
                  v-model="searchGender"
                  label="เพศ"
                  dense
                  outlined
                  hide-details
                ></v-select>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="searchTel"
                  :label="$session.getAll().data.shopId !== shopNameData.SHOP_ID_CHUBB ? 'เบอร์โทรศัพท์':'รหัสพนักงาน'"
                  dense
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
          <v-col class="text-center">
            <v-btn color='success' dark @click.stop="filterData()">ค้นหา</v-btn>
            <v-btn color='error' dark @click.stop="getDataList(), date1 = [], resetSearch()">ยกเลิก</v-btn>
          </v-col>
        </v-row>
          </v-container>

          <v-row>
            <v-col cols="12">
              <div v-if="dataReady">
                <v-card-title>
                  <v-text-field
                    v-model="searchAll2"
                    label="ค้นหาข้อมูล"
                    filled
                    dense
                    prepend-inner-icon="mdi-magnify"
                  ></v-text-field>
                </v-card-title>
                <v-card-text>
                  <v-data-table
                    :headers="columns"
                    :items="dataItem"
                    :options.sync="tableOptions"
                    :server-items-length="serverMode ? totalMembers : -1"
                    :loading="tableLoading"
                    :search="serverMode ? '' : searchAll2"
                    :footer-props="{ 'items-per-page-options': [10, 25, 50, 100] }"
                  >
                    <template v-slot:[`item.currentPoint`]="{ item }">
                      {{ formatNumber(item.currentPoint) }}
                    </template>
                    <template v-slot:[`item.collectPoint`]="{ item }">
                      {{ formatNumber(item.collectPoint) }}
                    </template>
                    <template v-slot:[`item.age`]="{ item }">
                      {{ formatNumber(item.age) + " ปี" }}
                    </template>
                    <template v-slot:[`item.picture`]="{ item }">
                      <v-avatar color="primary" size="40">
                        <img :src="item.picture || shopLogo" alt="img" @error="fallbackToShopLogo"
                      /></v-avatar>
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            dark
                            class="btn-color"
                            fab
                            x-small
                            @click.stop="
                              (dialogData = false),
                                getDataById(item),
                                getDataImg(item),
                                personalData(item),
                                getDataHis(item),
                                addMemberId(item)
                            "
                          >
                            <v-icon dark> mdi-account </v-icon>
                          </v-btn>
                        </template>
                        <span>ดูข้อมูล</span>
                      </v-tooltip>
                    </template>
                    <template v-slot:[`item.statusUploadPicture`]="{ item }">
                      <v-simple-checkbox
                        v-model="item.statusUploadPicture"
                      ></v-simple-checkbox>
                    </template>
                  </v-data-table>
                </v-card-text>
              </div>
              <div v-if="!dataReady" class="text-center">
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </div>
            </v-col>
          </v-row>
        </div>
        <div v-if="showTabel === false">
          <v-row>
            <v-col
              :cols="resCol === '12' ? '12' : '4'"
              style="padding-right: 0"
              :class="resCol === '12' ? 'pl-0' : ''"
            >
              <v-sheet color="#f8f9fa" height="100vh" width="100%">
                <v-container>
                  <div class="center">
                    <v-avatar size="107">
                      <img alt="Avatar" :src="personal.imgProfile"
                    /></v-avatar>
                  </div>
                  <div class="center">
                    <h3>{{ personal.name }}</h3>
                  </div>
                  <div class="center">
                    <h2>
                      {{ formatNumber(personal.currentPoint) }}
                      <span style="font-size: 18px">คะแนน</span>
                    </h2>
                  </div>
                  <div class="center" style="flex-direction: column; align-items: center; padding-bottom: 10px">
                    <div v-if="expirySchedule && expirySchedule.items.length > 0" style="color: #e65100">
                      <v-icon small color="#e65100">mdi-clock-alert-outline</v-icon>
                      {{ formatNumber(expirySchedule.items[0].point) }} คะแนน หมดอายุ {{ thaiDate(expirySchedule.items[0].expireDate) }}
                    </div>
                    <v-btn
                      v-if="expirySchedule"
                      small
                      text
                      color="primary"
                      @click="dialogExpiry = true"
                    >ดูวันหมดอายุคะแนน</v-btn>
                  </div>
                  <div>
                    <div style="padding-bottom: 15px">
                      <h3 style="font-size: 20px !important">ข้อมูล</h3>
                    </div>
                    <div>
                      <v-row>
                        <v-col>ชื่อ</v-col>
                        <!-- <v-col class="text-right">{{ personal.surname }}</v-col> -->
                        <v-col
                          v-if="editDataNameCustomer === true"
                          class="text-right"
                          >{{ personal.surname }}
                          <v-icon @click="editDataNameCustomer = false"
                            >mdi-pencil</v-icon
                          ></v-col
                        >
                        <v-col v-else>
                          <div style="display: flex; justify-content: center">
                            <v-text-field
                              v-model="personal.surname"
                              width="100px"
                              dense
                              solo
                              hide-details
                            ></v-text-field>
                            <v-icon @click="editNameCustomer()"
                              >mdi-content-save</v-icon
                            >
                          </div>
                        </v-col>
                      </v-row>
                      <v-row v-if="$session.getAll().data.shopId !== 'SD_1737957295593'">
                        <v-col>เพศ</v-col>
                        <v-col class="text-right"
                          >{{
                            personal.icon === "mdi-gender-male"
                              ? "ผู้ชาย"
                              : personal.icon === "mdi-gender-female"
                              ? "ผู้หญิง"
                              : ""
                          }}<v-icon
                            :color="
                              personal.icon === 'mdi-gender-male'
                                ? 'blue'
                                : personal.icon === 'mdi-gender-female'
                                ? 'pink'
                                : ''
                            "
                            >{{ personal.icon }}</v-icon
                          ></v-col
                        >
                      </v-row>
                      <v-row>
                        <v-col>{{$session.getAll().data.shopId !== shopNameData.SHOP_ID_CHUBB ? 'เบอร์โทรศัพท์':'รหัสพนักงาน'}}</v-col>
                        <v-col v-if="editDataTel === true" class="text-right"
                          >{{ personal.tel }}
                          <v-icon @click="editDataTel = false"
                            >mdi-pencil</v-icon
                          ></v-col
                        >
                        <v-col v-else>
                          <div style="display: flex; justify-content: center">
                            <v-text-field
                              v-if="$session.getAll().data.shopId !== shopNameData.SHOP_ID_CHUBB"
                              v-model="personal.tel"
                              width="100px"
                              dense
                              solo
                              hide-details
                              v-mask="'###-###-####'"
                            ></v-text-field>
                            <v-text-field
                              v-if="$session.getAll().data.shopId === shopNameData.SHOP_ID_CHUBB"
                              v-model="personal.tel"
                              width="100px"
                              dense
                              solo
                              hide-details
                            ></v-text-field>
                            <v-icon @click="editTel()">mdi-content-save</v-icon>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>หมายเหตุ</v-col>
                        <v-col v-if="editDataRemark === true" class="text-right"
                          >{{ personal.remark }}
                          <v-icon @click="editDataRemark = false"
                            >mdi-pencil</v-icon
                          ></v-col
                        >
                        <v-col v-else>
                          <div style="display: flex; justify-content: center">
                            <v-text-field
                              v-model="personal.remark"
                              width="100px"
                              dense
                              solo
                              hide-details
                            ></v-text-field>
                            <v-icon @click="editRemark()"
                              >mdi-content-save</v-icon
                            >
                          </div>
                        </v-col>
                      </v-row>
                      <v-row v-if="$session.getAll().data.shopId !== 'SD_1737957295593'">
                        <v-col>วันเกิด</v-col>
                        <v-col
                          v-if="editDataBirthDate === true"
                          class="text-right"
                          >{{ personal.birthday }}
                          <v-icon @click="editDataBirthDate = false"
                            >mdi-pencil</v-icon
                          ></v-col
                        >
                        <v-col v-else>
                          <div style="display: flex; justify-content: center">
                            <!-- <v-text-field v-model="personal.birthday" width='100px' dense solo hide-details></v-text-field> -->
                            <v-menu
                              ref="menu1"
                              v-model="menu1"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="personal.birthday"
                                  outlined
                                  v-bind="attrs"
                                  style="background-color: #efefef"
                                  readonly
                                  dense
                                  hide-details
                                  v-on="on"
                                  append-icon="mdi-calendar"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                ref="picker1"
                                v-model="newBirthday"
                                :active-date.sync="activePicker"
                                :max="new Date().toISOString().substr(0, 10)"
                                locale="th-th"
                                min=" 1950-01-01"
                                @change="save1"
                              ></v-date-picker>
                            </v-menu>
                            <v-icon
                              style="display: flex; align-items: normal"
                              @click="editBirthDate()"
                              >mdi-content-save</v-icon
                            >
                          </div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>email</v-col>
                        <v-col v-if="editEmail === true" class="text-right"
                          >{{ personal.email }}
                          <v-icon @click="editEmail = false"
                            >mdi-pencil</v-icon
                          ></v-col
                        >
                        <v-col v-else>
                          <div style="display: flex; justify-content: center">
                            <v-text-field
                              v-model="personal.email"
                              width="100px"
                              dense
                              solo
                              hide-details
                            ></v-text-field>
                            <v-icon @click="editEmailfunc()"
                              >mdi-content-save</v-icon
                            >
                          </div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>รหัส</v-col>
                        <v-col class="text-right">{{
                          personal.memberId
                        }}</v-col>
                      </v-row>
                      <v-row>
                        <v-col>ระดับ</v-col>
                        <v-col class="text-right">{{
                          personal.levelName
                        }}</v-col>
                      </v-row>
                      <v-row>
                        <v-col>วันที่สมัคร</v-col>
                        <v-col class="text-right">
                          {{ personal.createDate }}</v-col
                        >
                      </v-row>
                      <v-row v-for='i in personal.regisCustomFeild' :key='i'>
                        <v-col>{{ i.customFeildName }}</v-col>
                        <v-col class="text-right">
                          {{ i.value }}</v-col
                        >
                      </v-row>
                    </div>
                  </div>
                </v-container>
              </v-sheet>
            </v-col>
            <v-divider vertical></v-divider>

            <v-col
              style="padding-left: 0"
              :class="resCol === '12' ? 'pr-0' : ''"
            >
              <v-sheet color="#f8f9fa" height="100vh" width="100%">
                <v-container>
                  <div>
                    <v-container>
                      <v-row>
                        <v-col cols="10">
                          <h1>ตรวจสอบรายการย้อนหลัง</h1>
                        </v-col>
                        <v-col class="text-right">
                          <v-btn
                            fab
                            small
                            color="#1c437c"
                            dark
                            @click="
                              (showTabel = true),
                                (showTablePackage = false),
                                getDataList()
                            "
                            ><span style="font-size: large; color: #fff"
                              >X</span
                            ></v-btn
                          >
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-btn
                            :loading="loading2"
                            @click="Search_1month(), (showTablePackage = false)"
                            :color="Onemonth ? '#1976D2' : '#b6b6b6'" dark
                            class="me-1 mb-1"
                            >เดือนปัจจุบัน</v-btn
                          >
                          <v-btn
                            :loading="loading2"
                            @click="Search_3month(), (showTablePackage = false)"
                            :color="Threemonth ? '#1976D2' : '#b6b6b6'" dark
                            class="me-1 mb-1"
                            >ย้อนหลัง 3 เดือน</v-btn
                          >
                          <v-btn
                            :loading="loading2"
                            @click="Search_6month(), (showTablePackage = false)"
                            :color="Sixmonth ? '#1976D2' : '#b6b6b6'" dark
                            class="me-1 mb-1"
                            >ย้อนหลัง 6 เดือน</v-btn
                          >
                          <v-btn
                            :loading="loading2"
                            @click="Search_1year(), (showTablePackage = false)"
                            :color="Oneyear ? '#1976D2' : '#b6b6b6'" dark
                            class="me-1 mb-1"
                            >ย้อนหลัง 1 ปี</v-btn
                          >
                          <v-btn @click="getPackage()"
                          dark
                          :color="packageButton ? '#1976D2' : '#b6b6b6'"
                          class="me-1 mb-1"
                            ><v-icon>mdi-ticket-confirmation</v-icon
                            >แพ็กเกจ</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-container>
                  </div>
                  <div v-if="!showTablePackage">
                    <v-data-table
                      :headers="headers"
                      :items="processedItems"
                      :items-per-page="10"
                      height="520"
                    >
                      <template v-slot:[`item.date`]="{ item }">
                        {{ thaiFormattedDate(item.date) }}
                      </template>
                      <template v-slot:[`item.amount`]="{ item }">
                        {{ formatNumber(item.amount) }}
                      </template>
                      <template v-slot:[`item.point`]="{ item }">
                        {{ formatNumber(item.point) }}
                      </template>
                      <template v-slot:[`item.pointUse`]="{ item }">
                        {{ formatNumber(item.pointUse) }}
                      </template>
                      <template v-slot:[`item.refId`]="{ item }">
                        {{ item.refId }}
                      </template>
                    </v-data-table>
                  </div>
                  <div v-if="showTablePackage">
                    <v-data-table
                      :headers="headersPackage"
                      :items="myPackage"
                      :items-per-page="10"
                      height="520"
                    >
                      <template v-slot:[`item.packageImg`]="{ item }">
                        <v-avatar color="primary" size="40">
                          <img :src="item.packageImg" alt="img"
                        /></v-avatar>
                      </template>
                      <template v-slot:[`item.packagePrice`]="{ item }">
                        {{ formatNumber(item.packagePrice) + " บาท" }}
                      </template>
                      <template
                        v-slot:[`item.balanceAmount`]="{ item }"
                        style="display: inline-grid; padding-top: 14px"
                      >
                        <div style="display: inline-block">
                          <div>
                            {{ showDecimal(item.balanceAmount) + " ครั้ง" }}
                          </div>
                          <v-btn
                            color="#6a6a6a"
                            style="color: white !important"
                            x-small
                            @click="
                              (dialogReturnPackage = true), (formView = item)
                            "
                            ><v-icon small>mdi-cog</v-icon>แก้ไขโควต้า</v-btn
                          >
                        </div>
                        <!-- {{ showDecimal(item.balanceAmount) + ' ครั้ง'}}
                        <v-btn color="#6a6a6a" style="color:white !important" x-small @click="dialogReturnPackage = true, formView = item"><v-icon small>mdi-cog</v-icon>แก้ไขโควต้า</v-btn> -->
                      </template>
                      <template v-slot:[`item.amount`]="{ item }">
                        {{ formatNumber(item.amount) + " ครั้ง" }}
                      </template>
                      <template v-slot:[`item.CREATE_DATE`]="{ item }">
                        {{ thaiFormattedLAST_Date(item.CREATE_DATE) }}
                      </template>
                      <template v-slot:[`item.expirePackage`]="{ item }">
                        {{ convertDate(item.expirePackage) }}
                        <v-btn
                          v-if="item.expirePackage !== ''"
                          color="#1b437c"
                          style="color: white !important"
                          x-small
                          @click="
                            (dialogChangeExpire = true), (dataPackage = item)
                          "
                          >เปลี่ยนวันหมดอายุ</v-btn
                        >
                      </template>
                      <template v-slot:[`item.action`]="{ item }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            {{ checkExpireAndNotHaveQuota(item) }}
                            <div v-if="item.startExpireAfterFirstUse === 'False'">
                              <v-btn
                                v-if="
                                  item.expirePackage * 1000 > today.getTime() &&
                                  item.balanceAmount > 0
                                "
                                style="background-color:"
                                v-bind="attrs"
                                dark
                                v-on="on"
                                class="btn-color mb-2"
                                small
                                color="#38a815"
                                @click="useQuotaPackage(item)"
                              >
                                หักโควต้า
                              </v-btn>
                            </div>
                            <div v-else>
                              <div v-if="item.expirePackage === ''">
                                 <v-btn
                                  v-if="
                                    item.balanceAmount > 0
                                  "
                                  style="background-color:"
                                  v-bind="attrs"
                                  dark
                                  v-on="on"
                                  class="btn-color mb-2"
                                  color="#38a815"
                                  small
                                  @click="useQuotaPackage(item)"
                                >
                                  หักโควต้า
                                </v-btn>
                              </div>
                              <div v-else>
                                <v-btn
                                  v-if="
                                    item.expirePackage * 1000 > today.getTime() && item.balanceAmount > 0
                                  "
                                  style="background-color:"
                                  v-bind="attrs"
                                  dark
                                  v-on="on"
                                  class="btn-color mb-2"
                                  color="#38a815"
                                  small
                                  @click="useQuotaPackage(item)"
                                >
                                  หักโควต้า
                                </v-btn>
                                <p class="mb-0" style="color: #1b437c !important;font-weight: 100 !important;" v-else>
                                  หมดอายุ
                                </p>
                                </div>
                            </div>
                          </template>
                          <span>ดูข้อมูล</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </div>
                </v-container>
              </v-sheet>
            </v-col>
          </v-row>
        </div>
        <v-row>
          <!-- Data -->
          <v-dialog v-model="dialogData" persistent max-width="50%">
            <v-card max-width="100%">
              <v-card-actions>
                <v-col id="margin">
                  <v-row justify="center">
                    <template slot="progress">
                      <v-progress-linear
                        color="deep-purple"
                        height="10"
                        indeterminate
                      ></v-progress-linear>
                    </template>

                    <v-avatar
                      color="teal"
                      size="190"
                      style="margin-bottom: 50px"
                    >
                      <img alt="user" :src="this.fromUpdate.picture" />
                    </v-avatar>
                    <v-card-text
                      align="center"
                      class="mx-0"
                      style="
                        position: absolute;
                        top: 205px;
                        z-index: 2;
                        background-color: white;
                        width: 150px;
                      "
                    >
                      <div class="my-4 text-subtitle-1">ข้อมูลส่วนตัว</div>
                    </v-card-text>

                    <v-card-text align="left" class="mx-0" style="z-index: 1">
                      <div
                        style="
                          padding: 20px;
                          padding-top: 20px;
                          border: 2px solid #a5becc;
                          border-radius: 25px;
                          margin-bottom: 10px;
                        "
                      >
                        <div style="font-weight: bold">ชื่อลูกค้า</div>
                        <v-text-field
                          style="padding: 10px !important"
                          outlined
                          hide-details
                          dense
                          v-model="fromUpdate.name"
                        ></v-text-field>
                        <div style="font-weight: bold">{{$session.getAll().data.shopId !== shopNameData.SHOP_ID_CHUBB ? 'เบอร์โทรศัพท์':'รหัสพนักงาน'}}</div>
                        <v-text-field
                          style="padding: 10px !important"
                          hide-details
                          outlined
                          dense
                          v-model="fromUpdate.tel"
                        ></v-text-field>
                        <div style="font-weight: bold">วันเกิด</div>
                        <v-text-field
                          style="padding: 10px !important"
                          hide-details
                          outlined
                          dense
                          v-model="fromUpdate.birthDay"
                        ></v-text-field>
                        <v-row>
                          <v-col class="text-center">
                            <div
                              style="
                                display: flex;
                                justify-content: center;
                                align-items: center;
                              "
                            >
                              <v-card
                                @click="chooseImage"
                                class="image-input"
                                :style="{
                                  'background-image': `url(${formupdateA.pictureUrlPreviewA})`,
                                  'background-size': 'contain',
                                  'background-position': 'center center',
                                  'background-repeat': 'no-repeat',
                                  'border-radius': '21px',
                                }"
                              >
                                <div
                                  v-if="!formupdateA.pictureUrlPreviewA"
                                  class="placeholder"
                                  style="
                                    justify-content: center;
                                    align-items: center;
                                    display: flex;
                                    font-size: 18px;
                                  "
                                >
                                  <img
                                    style="width: 100%"
                                    src="https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/Product%20Card%20(1).png?alt=media&token=02eabd10-4da6-47b5-aacd-5cd19f219bda&_gl=1*ob4i8q*_ga*MzA1MzI2OTI0LjE2ODk5OTI5MzA.*_ga_CW55HF8NVT*MTY5NzEwMTEwMC4yOS4xLjE2OTcxMDE4MTEuNTIuMC4w"
                                  />
                                </div>
                                <input
                                  style="display: none"
                                  class="file-input"
                                  ref="fileInputA"
                                  type="file"
                                  @input="onSelectFile"
                                />
                              </v-card>
                            </div>
                            <p class="text-center">ขนาดแนะนำ 400x400</p>
                          </v-col>
                          <v-col>
                            <div
                              style="
                                display: flex;
                                justify-content: center;
                                align-items: center;
                              "
                            >
                              <v-card
                                @click="chooseImageB"
                                class="image-input"
                                :style="{
                                  'background-image': `url(${formupdateB.pictureUrlPreviewB})`,
                                  'background-size': 'contain',
                                  'background-position': 'center center',
                                  'background-repeat': 'no-repeat',
                                  'border-radius': '21px',
                                }"
                              >
                                <span
                                  v-if="!formupdateB.pictureUrlPreviewB"
                                  class="placeholder"
                                  style="
                                    justify-content: center;
                                    align-items: center;
                                    display: flex;
                                    font-size: 18px;
                                  "
                                  ><img
                                    style="width: 100%"
                                    src="https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/Product%20Card%20(2).png?alt=media&token=91327d08-1a94-46e6-a460-86c7e4691da4&_gl=1*6kzpzd*_ga*MzA1MzI2OTI0LjE2ODk5OTI5MzA.*_ga_CW55HF8NVT*MTY5NzEwMTEwMC4yOS4xLjE2OTcxMDIzNDMuNjAuMC4w"
                                /></span>
                                <input
                                  style="display: none"
                                  class="file-input"
                                  ref="fileInputB"
                                  type="file"
                                  @input="onSelectFileB"
                                />
                              </v-card>
                            </div>
                            <p class="text-center">ขนาดแนะนำ 400x400</p>
                          </v-col>
                        </v-row>
                      </div>
                      <h4
                        v-if="memberActivity.length > 0"
                        style="font-weight: bold; z-index: 2"
                      >
                        กิจกรรมกรอกข้อมูลที่ลูกค้าเคยเข้าร่วม
                      </h4>
                      <div
                        v-if="memberActivity.length > 0"
                        style="
                          z-index: 1;
                          padding: 20px;
                          padding-top: 20px;
                          border: 2px solid #a5becc;
                          border-radius: 25px;
                          margin-bottom: 10px;
                        "
                      >
                        <div v-for="(item, i) in memberActivity" :key="i">
                          <v-text-field
                            v-if="item.field1Value"
                            :label="item.field1Title"
                            outlined
                            dense
                            v-model="item.field1Value"
                          ></v-text-field>
                          <v-text-field
                            v-if="item.field2Value"
                            :label="item.field2Title"
                            outlined
                            dense
                            v-model="item.field2Value"
                          ></v-text-field>
                        </div>
                      </div>
                    </v-card-text>

                    <v-btn
                      elevation="2"
                      class="btn-color"
                      dark
                      x-large
                      @click="dialogData = false"
                    >
                      ปิด
                    </v-btn>
                  </v-row>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dailogViewRedeem" persistent max-width="400">
            <v-card>
              <v-container>
                <v-card-title style="padding-bottom: 3px">
                  <v-icon color="green" class="mr-2">mdi-check-circle</v-icon
                  >ยืนยันการใช้แพคเกจ {{ dailogViewRedeem }}
                </v-card-title>
                <v-divider
                  style="
                    margin-top: 1rem !important;
                    margin-bottom: 1rem !important;
                  "
                ></v-divider>
                <!-- <v-card-text v-if="!statusViewRedeem">
                  <v-alert dense outlined type="error">
                    <strong>ไม่พบข้อมูลแพคเกจ</strong>
                  </v-alert>
                </v-card-text> -->
                <div v-if="formView">
                  ข้อมูลลูกค้า
                  <div style="display: flex">
                    <div class="mr-4 pt-1">
                      <v-avatar color="primary" size="60">
                        <img :src="formView.picture" alt="img"
                      /></v-avatar>
                    </div>
                    <div>
                      <div>รหัสสมาชิก: {{ formView.memberId }}</div>
                      <div>ชื่อไลน์ลูกค้า: {{ formView.name }}</div>
                      <div>ชื่อลูกค้า: {{ formView.nameCustomer }}</div>
                    </div>
                  </div>
                </div>
                <v-divider
                  style="
                    margin-top: 1rem !important;
                    margin-bottom: 1rem !important;
                  "
                ></v-divider>
                <v-card-text v-if="loadingPacka === false">
                  <div>
                    <div>
                      <div class="pb-0" v-if="formView">
                        <h3 class="text-center">{{ formView.packageName }}</h3>
                      </div>
                    </div>
                    <div
                      cols="12"
                      style="padding-top: 15px; margin-bottom: 35px"
                    >
                      <!-- <p class="mx-auto">ข้อมูลแพคเกจ</p> -->
                      <v-img
                        v-if="formView"
                        class="mx-auto"
                        style="border-radius: 10px"
                        :src="formView.packageImg"
                        max-width="170"
                      ></v-img>
                    </div>
                  </div>
                  <div v-if="formView">
                    <div cols="12">
                      <h3 class="text-center">
                        คงเหลือ {{ showDecimal(formView.balanceAmount) }}/{{
                          formView.amount
                        }}
                      </h3>
                    </div>
                  </div>
                  <v-text-field
                    v-if="statusCheckBranch"
                    outlined
                    dense
                    label="จำนวนที่ต้องการใช้"
                    v-model="amountOf"
                  >
                  </v-text-field>
                  <div>
                    <v-alert v-if="!statusCheckBranch" outlined type="error" text border="left">
                      <p class="mb-2">สาขาที่สามารถใช้ได้</p>
                      <v-chip v-for="(item, i) in formView.useInBranch" :key="i">
                        {{item}}
                      </v-chip>
                    </v-alert>
                    <div class="text-center">
                      <v-btn
                        v-if="statusCheckBranch"
                        class="mr-3"
                        color="green"
                        style="color: white !important"
                        :disabled="
                          !amountOf ||
                          parseFloat(amountOf) >
                            parseFloat(formView.balanceAmount) ||
                          parseFloat(amountOf) === 0 || !statusCheckBranch
                        "
                        @click="updateUsePackage()"
                        >ยืนยัน</v-btn
                      >
                      <v-btn dark color="red darken-1" @click="clearfFormView()"
                        >ยกเลิก</v-btn
                      >
                    </div>
                  </div>
                </v-card-text>
                <v-card-text v-if="loadingPacka === true" class="pa-5">
                  ระบบกำลังตัดแพ๊กเกจ รอสักครู่
                  <v-progress-circular
                    :size="20"
                    :width="7"
                    color="#203452"
                    indeterminate
                  ></v-progress-circular>
                </v-card-text>
              </v-container>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogReturnPackage" persistent max-width="400">
            <v-card>
              <v-container>
                <v-card-title style="padding-bottom: 3px">
                  <v-icon color="green" class="mr-2">mdi-keyboard-return</v-icon
                  >แก้ไขโควต้าแพ็กเกจ
                </v-card-title>
                <v-divider
                  style="
                    margin-top: 1rem !important;
                    margin-bottom: 1rem !important;
                  "
                ></v-divider>
                <div v-if="formView">
                  ข้อมูลลูกค้า
                  <div style="display: flex">
                    <div class="mr-4 pt-1">
                      <v-avatar color="primary" size="60">
                        <img :src="formView.picture" alt="img"
                      /></v-avatar>
                    </div>
                    <div>
                      <div>รหัสสมาชิก: {{ formView.memberId }}</div>
                      <div>ชื่อไลน์ลูกค้า: {{ formView.name }}</div>
                      <div>ชื่อลูกค้า: {{ formView.nameCustomer }}</div>
                      <div>
                        จำนวนโควต้าปัจจุบัน: {{ formView.balanceAmount }}
                      </div>
                    </div>
                  </div>
                </div>
                <v-divider
                  style="
                    margin-top: 1rem !important;
                    margin-bottom: 1rem !important;
                  "
                ></v-divider>
                <v-card-text>
                  <v-text-field
                    type="number"
                    outlined
                    dense
                    label="กรอกจำนวนที่ต้องการแก้ไข"
                    v-model="amountOfEdit"
                  >
                  </v-text-field>
                  <div v-if="formView">
                    <v-alert
                      dense
                      type="error"
                      v-if="parseFloat(amountOfEdit) > formView.amount"
                    >
                      จำนวนที่แก้ไขต้องไม่มากกว่าจำนวนทั้งหมด
                    </v-alert>
                  </div>
                  <div>
                    <div class="text-center">
                      <v-btn
                        class="mr-3"
                        color="green"
                        style="color: white !important"
                        :disabled="
                          !amountOfEdit ||
                          parseFloat(amountOfEdit) < 0 ||
                          parseFloat(amountOfEdit) > formView.amount
                        "
                        @click="editAmountPackage()"
                        >ยืนยัน</v-btn
                      >
                      <v-btn
                        dark
                        color="red darken-1"
                        @click="dialogReturnPackage = false"
                        >ยกเลิก</v-btn
                      >
                    </div>
                  </div>
                </v-card-text>
                <!-- <v-card-text v-if="!statusViewRedeem">
                  <v-alert dense outlined type="error">
                    <strong>ไม่พบข้อมูลแพคเกจ</strong>
                  </v-alert>
                </v-card-text> -->
              </v-container>
            </v-card>
          </v-dialog>

          <v-dialog
            transition="dialog-top-transition"
            max-width="600"
            v-model="dialogImport"
          >
            <v-card>
              <v-toolbar
                  color="#1c437c"
                  elevation="0"
                  dark
                  style="justify-content: left !important;display: flex"
                ><v-toolbar-title><v-icon>mdi-file-account</v-icon>นำเข้าข้อมูลสมาชิก</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <div class="pa-4">
                  <v-row>
                    <v-col>
                      <input
                        type="file"
                        @change="importData"
                        accept=".xls,.xlsx"
                      />
                    </v-col>
                    <v-col>
                      <v-data-table
                      :headers="columnsLMG"
                      :items="dataItemTableLMG"
                      :items-per-page="10"
                      >
                      </v-data-table>
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn @click="uploadData" style="background-color: #1b437c !important" :loading="loadingImport" class="btn btn-default text-white">upload</v-btn>
                  <v-btn
                    text
                    @click="dialogImport = false, dataItemTableLMG = []"
                  >Close</v-btn>
                </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog
            transition="dialog-top-transition"
            max-width="600"
            max-height="250"
            v-model="dialogImportError"
          >
            <v-card min-height="250">
              <v-toolbar
                  color="red"
                  elevation="0"
                  dark
                  style="justify-content: left !important;display: flex"
                ><v-toolbar-title><v-icon>mdi-file-document</v-icon>นำเข้าข้อมูลสมาชิกไม่สำเร็จ</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <div class="pa-4" style="font-size:18px;">
                  มีรหัสสมาชิกซ้ำในระบบกรุณานำออกจากไฟล์
                </div>
                <div class="pa-4">
                  <v-btn style="background-color: #1b437c !important" block>
                  <v-icon left style="color: white !important">mdi-download</v-icon>
                  <download-excel
                    class="btn btn-default text-white"
                    :data="dataError"
                    :fields="export_fields_error"
                    :type="exportType"
                    :worksheet="exportWorksheet"
                    :name="exportFileerror"
                  >
                    กดเพื่อดาวน์โหลดรหัสสมาชิกซ้ำ
                  </download-excel>
                </v-btn>
                </div>
              </v-card-text>
              <v-card-actions class="justify-end">
                  <v-btn
                    text
                    @click="dialogImportError = false"
                  >Close</v-btn>
                </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogExpiry" max-width="420">
            <v-card v-if="expirySchedule" style="padding: 16px">
              <v-card-title style="padding: 0 0 12px">วันหมดอายุคะแนน — {{ personal.name }}</v-card-title>
              <v-card-text style="padding: 0">
                <div v-if="expirySchedule.items.length === 0 && expirySchedule.noExpiryPoint === 0">
                  ไม่มีคะแนนคงเหลือ
                </div>
                <v-simple-table v-else dense>
                  <thead>
                    <tr>
                      <th>วันหมดอายุ</th>
                      <th class="text-right">คะแนน</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in expirySchedule.items" :key="row.expireDate">
                      <td>{{ thaiDate(row.expireDate) }}</td>
                      <td class="text-right">{{ formatNumber(row.point) }}</td>
                    </tr>
                    <tr v-if="expirySchedule.noExpiryPoint > 0">
                      <td>ไม่มีวันหมดอายุ</td>
                      <td class="text-right">{{ formatNumber(expirySchedule.noExpiryPoint) }}</td>
                    </tr>
                    <tr>
                      <th>รวม</th>
                      <th class="text-right">{{ formatNumber(expirySchedule.totalPoint) }}</th>
                    </tr>
                  </tbody>
                </v-simple-table>
                <div class="pt-3">ถ้าลูกค้าแลกของรางวัล ระบบจะหักคะแนนที่ใกล้หมดอายุก่อน</div>
                <div v-if="Number(expirySchedule.totalPoint) !== Number(personal.currentPoint)" class="pt-2" style="color: #c62828">
                  ยอดรวมรายก้อนไม่ตรงกับคะแนนคงเหลือ ({{ formatNumber(personal.currentPoint) }}) กรุณาแจ้งทีมงาน
                </div>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn text @click="dialogExpiry = false">ปิด</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
// import constants from '@/constants.js'
import axios from 'axios' // api
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import VuetifyMoney from '../VuetifyMoney.vue'
import JsonExcel from 'vue-json-excel'
import moment from 'moment' // แปลง date

export default {
  components: {
    XLSX,
    readXlsxFile,
    downloadExcel: JsonExcel,
    VuetifyMoney
  },
  created () {
    setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      dataError: null,
      loading2: false,
      dialogImportError: false,
      loadingImport: false,
      amountOfEdit: null,
      amountOf: null,
      today: new Date(),
      dataPackage: null,
      pickerChangeExpire: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      dialogChangeExpire: false,
      editDataTel: true,
      menu1: false,
      editDataNameCustomer: true,
      editDataBirthDate: true,
      editEmail: true,
      activePicker: null,
      newBirthday: null,
      headers: [
        { text: 'วันที่', value: 'date' },
        { text: 'บริการ', value: 'productExchangeRateName' },
        { text: 'ราคา', value: 'amount' },
        { text: 'คะแนนที่ได้รับ', value: 'point' },
        { text: 'คะแนนที่ใช้', value: 'pointUse' },
        { text: 'ของที่แลก', value: 'name' },
        { text: 'สถานะการรับของ', value: 'redeemStatus' },
        { text: 'เลขอ้างอิง', value: 'refId' }
      ],
      headersPackage: [
        { text: '', value: 'packageImg' },
        { text: 'ชื่อแพ็กเกจ', value: 'packageName', align: 'center' },
        { text: 'จำนวนทั้งหมด', value: 'amount', align: 'center' },
        { text: 'จำนวนที่เหลือ', value: 'balanceAmount', align: 'center' },
        { text: 'ราคาแพ็กเกจ', value: 'packagePrice', align: 'center' },
        { text: 'วันที่ซื้อแพ็กเกจ', value: 'CREATE_DATE', align: 'center' },
        { text: 'วันหมดอายุ', value: 'expirePackage', align: 'center' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      desserts: [],
      showTabel: true,
      PK: '',
      path: '/member/', // Path Model
      returnLink: '/system/ListMember',
      memberActivity: [],
      a: [],
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'รายการลูกค้า',
          disabled: false,
          href: '/System/ListMember'
        }
      ],
      // End Menu Config
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      date1: [],
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      code: 'BCH_', // Generate Code
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogReturnPackage: false,
      dialogImport: false,
      dialogData: false,
      fromUpdate: [],
      // END Dialog Config ADD EDIT DELETE
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      searchAll2: '',
      // Search Advanced
      search: {
        shopId: '',
        name: '',
        totalPoint: '',
        LevelName: ''
      },
      statusUploadPicture: false,
      // End Form Config ADD EDIT
      // Data Table Config
      columns: [],
      columnsLMG: [
        { text: 'AGENTID', value: 'agentId' },
        { text: 'คะแนน', value: 'point' },
        { text: 'level', value: 'Levelname' },
        { text: 'dwp', value: 'dwp' }
      ],
      dataItem: [],
      dataItemTableLMG: [],
      ItemLvL: [],
      // End Data Table Config

      // Config Import
      columnsImport: [
        { text: 'masBranchID', value: 'masBranchID' },
        { text: 'masBranchCode', value: 'masBranchCode' },
        { text: 'masBranchName', value: 'masBranchName' },
        { text: 'masCompanyCode', value: 'masCompanyCode' },
        { text: 'masCompanyName', value: 'masCompanyName' }
      ],
      editDataRemark: true,
      dataItemImportChecKHide: true,
      dataItemImport: [],
      showTablePackage: false,
      // End Config Import
      // Export Config
      exportType: 'xls',
      exportFileName: 'List-Member.xls',
      exportFile: 'รายชื่อผู้ใช้ที่จะถูกตัดคะแนนประจำเดือน.xls',
      exportWorksheet: 'WorkSheet',
      exportFileerror: 'รหัสสมาชิกซ้ำ.xls',
      export_fields_error: {
        รหัสสมาชิกที่ซ้ำ: 'barcodeNum'
      },
      export_fields: {
        lineId: 'linUserId',
        name: 'name',
        ระดับสมาชิก: 'LevelName',
        เบอร์โทรศัพท์: 'tel',
        วันที่สมัครสมาชิก: 'CREATE_DATE',
        คำตอบ1: 'field1Value',
        หัวข้อ2: 'field2Title',
        คำตอบ2: 'field2Value',
        หัวข้อ3: 'field3Title',
        คำตอบ3: 'field3Value',
        หัวข้อ4: 'field4Title',
        คำตอบ4: 'field4Value'
      },
      export_field: {
        linUserId: 'liffUserId',
        IdmemberBarcode: 'IdbarCodeMember',
        ชื่อไลน์: 'name',
        ชื่อ: 'nameCustomer',
        เพศ: 'gender',
        เบอร์โทรศัพท์: 'tel',
        คะแนนที่ได้รับ: 'collectPoint',
        คะแนนที่ถูกใช้: 'redeemPoint',
        คะแนนคงเหลือ: 'currentPoint',
        คะแนนที่จะถูกตัดเดือนนี้: 'balancePoint',
        email: 'email',
        วันเกิด: 'birthDay',
        ระดับ: 'LevelName',
        วันที่สมัครสมาชิก: 'CREATE_DATE',
        หมายเหตุ: 'remark'
      },
      export_data1: null,
      export_data: null,
      dataCustomFeildName: [],
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      objResultLevel: null,
      // End Export Config
      Company: [],
      datacheck: [],
      profile: {
        pic: null,
        name: '',
        genderIcon: '',
        color: '',
        colorGender: '',
        pictureUrlLevel: '',
        lineName: ''
      },
      myChartLevelMember: null,
      formupdateA: {
        pictureA: '',
        pictureUrlPreviewA: ''
      },
      formupdateB: {
        pictureB: '',
        pictureUrlPreviewB: ''
      },
      id: '',
      filesAddB: null,
      personalLoaded: {
        tel: '',
        surname: '',
        birthday: '',
        email: ''
      },
      expirySchedule: null,
      dialogExpiry: false,
      personal: {
        imgProfile: '',
        name: '',
        surname: '',
        levelName: '',
        gender: '',
        tel: '',
        birthday: '',
        createDate: '',
        coupon: '',
        memberId: '',
        pictureUrlLevel: '',
        collectPoint: '',
        currentPoint: '',
        icon: '',
        remark: '',
        email: ''
      },
      memberId: '',
      myPackage: null,
      dailogViewRedeem: false,
      formView: null,
      loadingPacka: false,
      searchBirthDay: '',
      searchlevel: '',
      searchGender: '',
      searchTel: '',
      datepickers: [],
      dataExchange: [],
      dataLevel: [],
      filter: [],
      statusCheckBranch: true,
      mapDataBranch: {},
      Onemonth: false,
      Threemonth: false,
      Sixmonth: false,
      Oneyear: false,
      packageButton: false,
      serverMode: true,
      totalMembers: 0,
      tableLoading: false,
      tableOptions: { page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [] }
    }
  },
  watch: {
    dynamicColumns: {
      handler (newColumns) {
        if (this.$session.getAll().data.shopId !== 'SD_1737957295593') {
          this.columns = newColumns
        } else {
          this.columns = newColumns.filter(item => item.text !== 'อายุ' && item.text !== 'วันเกิด' && item.text !== 'เพศ')
        }
      },
      immediate: true
    },
    menu1 (val) {
      val && setTimeout(() => (this.$refs.picker1.activePicker = 'YEAR'))
    },
    dialogChangeExpire (newQuestion, oldQuestion) {
      if (newQuestion) {
        // this.dataPackage = null
        this.pickerChangeExpire = new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10)
      }
    },
    tableOptions: {
      handler () {
        this.requestFetch()
      },
      deep: true
    },
    searchAll2 () {
      if (this.serverMode) {
        this.tableOptions.page = 1
        this.requestFetch()
      }
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  computed: {
    shopLogo () {
      const data = this.$session.getAll().data
      return (data && data.logo) || ''
    },
    dynamicColumns () {
      return [
        { text: 'โปรไฟล์', value: 'picture' },
        { text: 'ชื่อไลน์', value: 'name', align: 'left' },
        {
          text: this.$session.getAll().data.shopId !== 'SD_1737957295593'
            ? 'ชื่อลูกค้า'
            : 'ชื่อบริษัท',
          value: 'nameCustomer',
          align: 'left'
        },
        {
          text: this.$session.getAll().data.shopId !== this.shopNameData.SHOP_ID_CHUBB
            ? 'เบอร์โทรศัพท์'
            : 'รหัสพนักงาน',
          value: 'tel',
          align: 'center'
        },
        { text: 'อายุ', value: 'age', align: 'left' },
        { text: 'วันเกิด', value: 'birthDay', align: 'center' },
        { text: 'หมายเหตุ', value: 'remark', align: 'center' },
        { text: 'เพศ', value: 'gender', align: 'center' },
        { text: 'คะแนนที่ได้รับ', value: 'collectPoint', align: 'center' },
        { text: 'คะแนนคงเหลือ', value: 'currentPoint', align: 'center' },
        {
          text: 'คะแนนหมดอายุเดือนนี้',
          value: 'balancePoint',
          align: 'center'
        },
        { text: 'ระดับสมาชิก', value: 'LevelName', align: 'center' },
        // { text: 'อัปโหลดภาพ', value: 'statusUploadPicture', align: 'center' },
        { text: 'วันที่สมัคร', value: 'CREATE_DATE', align: 'center' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }

      ]
    },
    dateRangeText () {
      return this.date1.join(' - ')
    },
    processedItems () {
      return this.desserts.map((item) => ({
        ...item,
        // Check and replace values with placeholders where necessary
        productExchangeRateName: item.productExchangeRateName || '-',
        amount: item.amount || 0,
        point: item.point || 0,
        pointUse: item.pointUse || 0,
        name: item.name || '-'
      }))
    },
    resCol () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '12'
        case 'sm':
          return '12'
        case 'md':
          return '6'
        case 'lg':
          return '6'
        case 'xl':
          return '6'
      }
    }
  },
  async mounted () {
    this.dataReady = false
    this.getDataBranch()
    this.getLevel()
    this.getGender()
    this.getDataList()
    // if (this.$session.getAll().data.shopId ==='U4e23f7bf31b362622ff7c5c06dfdf350') {
    //   this.headers.forEach((header) => {
    //     if (header.text === 'บริการ') {
    //         header.value = 'bvpBillingNumber';
    //     }
    //   });
    // }
    if (
      this.$session.getAll().data.shopId ===
        'U97dd281445cde30a599a5f5515a4e937' ||
      this.$session.getAll().data.shopId === 'U60f3a4215c86a978d5f6191292ad0109'
    ) {
      this.columns.unshift({
        text: 'barcodeId',
        value: 'IdbarCodeMember',
        width: '120'
      })
    }
    if (
      this.$session.getAll().data.shopId === 'Uc12ec7164d5a4fb59c7f0f00044bdacf'
    ) {
      this.columns = this.columns.filter((item) => {
        return item.value !== 'collectPoint'
      })
    }
    this.getExportData()
    this.chart()
  },
  methods: {
    // searchData () {
    //   let sortData = []
    //   if (this.searchBirthDay) {
    //     sortData.push(
    //       `searchBirthDay=${encodeURIComponent(this.searchBirthDay)}`
    //     )
    //   }
    // },
    getDataLevel () {
      axios
        .get(this.DNS_IP + '/level/get?shopId=' + this.session.data.shopId)
        .then(res => {
          this.ItemLvL = res.data
          this.objResultLevel = this.ItemLvL.reduce((acc, item) => {
            acc[item.levelId] = item.name
            return acc
          }, {})
        })
      console.log('this.objResultLevel', this.objResultLevel)
    },
    async getDataBranch () {
      // Clear Data ทุกครั้ง
      // console.log('getDataCompany')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/master_branch/' +
            'get?shopId=' +
            this.session.data.shopId,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          if (response.data.status !== false) {
            response.data.forEach((item) => {
              this.mapDataBranch[item.masBranchID] = item.masBranchName
            })
            // this.branchLoyalty.unshift({'masBranchName': 'ทุกสาขา', 'masBranchID': 'ทุกสาขา'})
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
    },
    editAmountPackage () {
      this.dialogReturnPackage = false
      this.$swal({
        title: 'ต้องการ แก้ไขแพ็กเกจ ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          try {
            const url1 =
              this.DNS_IP +
              `/edit_package_log/edit/${this.formView.idPackageLog}`
            let dt1 = {
              amountOfEdit: this.amountOfEdit,
              CREATE_USER: this.session.data.userEmail,
              shopId: this.session.data.shopId,
              idPackageLog: this.formView.idPackageLog,
              amountBeforEdit: this.formView.balanceAmount
            }
            await axios.post(url1, dt1).then(async (response) => {
              if (response.data.status === true) {
                this.$swal({
                  title: 'เรียบร้อย',
                  type: 'success',
                  showCancelButton: false,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#b3b1ab',
                  confirmButtonText: 'ตกลง'
                })
                  .then(async (result) => {
                    this.amountOfEdit = null
                    this.dialogReturnPackage = false
                    this.amountOf = null
                    await this.getPackage()
                  })
                  .catch((error) => {
                    console.log(error)
                  })
              } else {
                this.$swal('ผิดพลาด', response.data.message, 'error')
                this.$router.push('/Master/Package')
                location.reload()
              }
            })
          } catch (error) {
            console.log('errir', error)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    },
    checkExpireAndNotHaveQuota (item) {
      const noExpireDate =
        item.expirePackage === null ||
        item.expirePackage === undefined ||
        item.expirePackage === 'None' ||
        Number(item.expirePackage) <= 0 ||
        isNaN(Number(item.expirePackage))
      if (noExpireDate) {
        return item.balanceAmount > 0 ? '' : 'หมดโควต้า'
      }
      if (item.expirePackage * 1000 > this.today.getTime()) {
        if (item.balanceAmount > 0) {
          return ''
        } else {
          return 'หมดโควต้า'
        }
      } else {
        if (item.startExpireAfterFirstUse === 'False') {
          return 'หมดอายุ'
        } else {
          return ''
        }
      }
    },
    clearfFormView () {
      try {
        this.formView = null
        this.amountOf = null
        this.dailogViewRedeem = false
        this.statusCheckBranch = true
      } catch (error) {
        console.log('fffff', error)
      }
    },
    showDecimal (item) {
      if (item.split('.')[1] === '0') {
        return item.split('.')[0]
      } else {
        return item
      }
    },
    fallbackToShopLogo (event) {
      if (this.shopLogo && event.target.src !== this.shopLogo) {
        event.target.src = this.shopLogo
      }
    },
    convertDate (arr) {
      if (arr === '') {
        return 'หมดอายุหลังจากใช้ครั้งแรก'
      }
      if (arr === null || arr === undefined || arr === 'None' || Number(arr) <= 0 || isNaN(Number(arr))) {
        return 'ไม่มีวันหมดอายุ'
      }
      return moment.unix(arr).add(543, 'years').format('DD/MM/YYYY')
    },
    async uploadData () {
      try {
        this.loadingImport = true
        console.log('this.dataItemTableLMG', this.dataItemTableLMG)
        await axios
          .post(this.DNS_IP + `/importData/add/LMG`, this.dataItemTableLMG)
          .then(async (response) => {
            if (response.data.status === true) {
              this.$swal({
                title: 'เรียบร้อย',
                type: 'success',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#b3b1ab',
                confirmButtonText: 'ตกลง'
              })
                .then(async (result) => {
                  this.dialogImport = false
                  this.dataItemTableLMG = []
                })
                .catch((error) => {
                  console.log(error)
                })
              this.loadingImport = false
            } else {
              this.dataItemTableLMG = []
              this.dataError = response.data.listDupnumber
              this.dialogImportError = true
              this.dialogImport = false
              this.loadingImport = false
              console.log('this.dataError', this.dataError)
            }
          })
        // await axios
        //   .post(this.DNS_IP + `/importData/add`, this.dataItemImport)
        //   .then(async (response) => {})
      } catch (error) {
        console.log('errir', error)
      }
    },
    save1 (date) {
      this.$refs.menu1.save(date)
      this.personal.birthday = date
    },
    async importData (event) {
      this.dataItemImport = []
      var input = event.target
      var reader = new FileReader()
      try {
        reader.onload = () => {
          var fileData = reader.result
          var wb = XLSX.read(fileData, { type: 'binary' })
          wb.SheetNames.forEach(async (sheetName) => {
            var rowObj = XLSX.utils.sheet_to_json(wb.Sheets[sheetName])
            const data = this.convertKeys(rowObj)
            // console.log('fffdf', data)
            this.dataItemImport = data
            console.log('this.dataItemImport', this.dataItemImport)
          })
        }
        reader.readAsBinaryString(input.files[0])
      } catch (error) {
        console.log('error', error)
      }
    },
    convertKeys (array) {
      this.dataItemTableLMG = array
      this.dataItemTableLMG.map((item) => {
        item.Levelname = this.objResultLevel[item.level]
      })
      console.log('ffffff', this.dataItemTableLMG)
      // try {
      //   return array
      //     .map((item) => ({
      //       nameCustomer: item['ชื่อสมาชิก'],
      //       gender: item['เพศ'],
      //       birthDay: item['วันเกิด'],
      //       registorDate: item['วันที่เข้าร่วม'],
      //       point: item['คะแนน'],
      //       tel: '0' + item['เบอร์โทรศัพท์'].toString(),
      //       // remark: item['หมายเหตุ'],
      //       // email: item['อีเมล LINE'] || null,
      //       shopId: this.$session.getAll().data.shopId
      //     }))
      //     .map((item2) => {
      //       // console.log('item2gender', item2.gender)
      //       item2.gender = item2.gender === 'หญิง' ? 'female' : item2.gender === 'ชาย' ? 'male' : 'ไม่ระบุ'
      //       // console.log('item2.gender', item2.gender)
      //       return item2
      //     })
      // } catch (error) {
      //   console.log('error convertKeys', error)
      // }
    },
    excelDateToJSDate (excelDate) {
      const daysBetween = excelDate // ลบ 1 เนื่องจาก Excel นับวันที่เริ่มต้นที่ 1900-01-01
      const millisecondsPerDay = 24 * 60 * 60 * 1000 // จำนวนมิลลิวินาทีในหนึ่งวัน

      const excelStartDate = new Date(1899, 11, 30) // วันที่เริ่มต้นของ Excel (1900-01-01 ใน Excel ถูกตัดสินใจว่าไม่ได้มี)
      const offsetMilliseconds = daysBetween * millisecondsPerDay

      const jsDate = new Date(excelStartDate.getTime() + offsetMilliseconds)
      const year = jsDate.getFullYear()
      const month = String(jsDate.getMonth() + 1).padStart(2, '0')
      const day = String(jsDate.getDate()).padStart(2, '0')

      return `${year}-${month}-${day}`
    },
    async updateUsePackage () {
      this.$swal({
        title: 'ต้องการ หักแพ็กเกจ ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          this.loadingPacka = true
          try {
            const url1 =
              this.DNS_IP +
              '/use_package/edit?shopId=' +
              this.session.data.shopId +
              '&token=' +
              this.formView.token
            let config1 = {
              headers: {
                shopId: this.formView.shopId,
                memberId: this.formView.memberId
              }
            }
            let dt1 = {
              token: this.$route.query.token,
              shopId: this.$route.query.shopId,
              brancId: this.$session.getAll().data.masBranchID,
              user: this.$session.getAll().data.userEmail,
              employeeId: this.$session.getAll().data.userId
            }
            if (this.amountOf) {
              if (this.amountOf.includes('.')) {
                dt1.amountOf = parseFloat(this.amountOf)
              } else {
                dt1.amountOf = parseInt(this.amountOf)
              }
            }
            await axios.post(url1, dt1, config1).then(async (response) => {
              if (response.data.status === true) {
                this.loadingPacka = false
                this.$swal({
                  title: 'เรียบร้อย',
                  type: 'success',
                  showCancelButton: false,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#b3b1ab',
                  confirmButtonText: 'ตกลง'
                })
                  .then(async (result) => {
                    this.dailogViewRedeem = false
                    this.amountOf = null
                    await this.getPackage()
                  })
                  .catch((error) => {
                    console.log(error)
                  })
              } else {
                this.$swal('ผิดพลาด', response.data.message, 'error')
                this.$router.push('/Master/Package')
                location.reload()
              }
            })
          } catch (error) {
            console.log('errir', error)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    },
    async useQuotaPackage (item) {
      this.dailogViewRedeem = true
      this.formView = item
      if (this.$session.getAll().data.shopId === 'U57de59022f079434e724afc24dd8b50a' || this.$session.getAll().data.shopId === 'U46b17db406ee6976c058cb98486957c4' || this.$session.getAll().data.shopId === 'U84bee5c35d25a597a87e85e0b3029330' || this.$session.getAll().data.shopId === 'U4581148094e2790fedc0cc1fa2ef755c') {
        this.formView.useInBranch = item.useInBranch
        if (item.useInBranch && item.useInBranch !== '' && item.useInBranch !== 'None' && item.useInBranch !== '[]' && item.useInBranch !== null) {
          let useInBranchList = JSON.parse(item.useInBranch)
          const found = useInBranchList.find((element) => element === parseInt(this.$session.getAll().data.masBranchID))
          if (found) {
            this.statusCheckBranch = true
          } else {
            this.statusCheckBranch = false
            this.formView.useInBranch = JSON.parse(this.formView.useInBranch)
            this.formView.useInBranch.forEach((item, index) => {
              this.formView.useInBranch[index] = this.mapDataBranch[item]
            })
          }
        }
      }
    },
    async getPackage () {
      this.Onemonth = false
      this.packageButton = true
      this.Threemonth = false
      this.Sixmonth = false
      this.Oneyear = false
      this.showTablePackage = true
      this.myPackage = []
      try {
        await axios
          .get(
            this.DNS_IP +
              `/PackageLog/getBystatusUse?memberId=${this.id}&shopId=${
                this.$session.getAll().data.shopId
              }`
          )
          .then(async (response) => {
            if (response.data.status === false) {
              this.myPackage = []
            } else {
              this.myPackage = response.data
            }
          })
      } catch (error) {
        console.log('errir', error)
      }
    },
    chooseFile () {
      this.$refs.fileInput.click()
    },
    onSelectFileImport () {
      const input = this.$refs.fileInput
      this.file = [...input.files]
      console.log('this.file', this.file.length)
      if (this.file.length > 0) {
        const file = this.file[0]

        // Create a new FileReader instance
        const reader = new FileReader()

        // Define the onload event handler
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result)

          // Parse the XLSX file
          const workbook = XLSX.read(data, { type: 'array' })

          // Get the first sheet name
          const sheetName = workbook.SheetNames[0]

          // Get the sheet data
          const sheet = workbook.Sheets[sheetName]

          // Convert the sheet data to JSON format
          const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 })
          const headers = jsonData[0]
          const rows = jsonData.slice(1)
          const result = rows.map((row) => {
            const obj = {}
            headers.forEach((header, index) => {
              obj[header] = row[index]
            })
            return obj
          })
          console.log('result', result)
          this.dataUserLine = result.filter(
            (item) => item.lineUserId !== undefined
          )
          this.selectAudience = file.name
          this.fileName = file.name
          console.log('file.name', file.name)
          // Log the resulting array
          console.log(result)
        }

        // Read the file as an ArrayBuffer
        reader.readAsArrayBuffer(file)
      } else {
        console.log('No file selected')
      }
    },
    calculateAge (birthday) {
      try {
        // console.log('birthday', new Date(birthday))
        var ageDifMs = Date.now() - new Date(birthday).getTime()
        var ageDate = new Date(ageDifMs) // miliseconds from epoch
        // console.log('ageDate', ageDate)
        return Math.abs(ageDate.getUTCFullYear() - 1970)
      } catch (error) {
        console.log('error', error)
      }
    },
    async getDataList () {
      this.serverMode = true
      this.searchAll = ''
      this.searchAll2 = ''
      this.tableOptions.page = 1
      this.requestFetch()
    },
    requestFetch () {
      if (!this.serverMode) return
      clearTimeout(this._fetchTimer)
      this._fetchTimer = setTimeout(() => {
        this.fetchMembersPage()
      }, 250)
    },
    async fetchMembersPage () {
      if (!this.serverMode) return
      this.tableLoading = true
      const page = this.tableOptions.page || 1
      const limit = this.tableOptions.itemsPerPage || 10
      let url =
        this.DNS_IP +
        '/member/Member?shopId=' +
        this.session.data.shopId +
        '&page=' +
        page +
        '&limit=' +
        limit
      if (this.searchAll2) {
        url += '&search=' + encodeURIComponent(this.searchAll2)
      }
      try {
        const res = await axios.get(url)
        const rows =
          res.data && Array.isArray(res.data.data) ? res.data.data : []
        this.totalMembers = res.data && res.data.total ? res.data.total : 0
        rows.forEach((el) => {
          el.age = this.calculateAge(el.birthDay)
        })
        this.dataItem = rows
      } catch (error) {
        console.log('fetchMembersPage error', error)
        this.dataItem = []
        this.totalMembers = 0
        this.$swal('ผิดพลาด', 'โหลดข้อมูลสมาชิกไม่สำเร็จ กรุณาลองใหม่', 'error')
      }
      this.tableLoading = false
      this.dataReady = true
    },
    buildExportData (rows) {
      this.export_data = rows
      this.export_data.map((item) => {
        if (item.regisCustomFeild && typeof item.regisCustomFeild === 'string') {
          try {
            item.regisCustomFeild = JSON.parse(item.regisCustomFeild)
          } catch (e) {
            item.regisCustomFeild = null
          }
        } else if (!item.regisCustomFeild) {
          item.regisCustomFeild = null
        }
        if (item.birthDay !== '' && item.birthDay) {
          item.birthDay = moment(item.birthDay)
            .add(543, 'years')
            .format('DD/MM/YYYY')
        } else {
          item.birthDay = ''
        }
        if (item.CREATE_DATE !== '' && item.CREATE_DATE) {
          item.CREATE_DATE = moment(item.CREATE_DATE)
            .add(543, 'years')
            .format('DD/MM/YYYY')
        } else {
          item.CREATE_DATE = ''
        }
      })
      let index = this.export_data.findIndex(
        (a) => a.regisCustomFeild !== null
      )
      this.dataCustomFeildName = []
      if (index !== -1) {
        this.export_data.forEach((item) => {
          if (item.regisCustomFeild) {
            item.regisCustomFeild.forEach((item2) => {
              if (
                item2.customFeildName &&
                !this.dataCustomFeildName.includes(item2.customFeildName)
              ) {
                this.dataCustomFeildName.push(item2.customFeildName)
                this.export_field[item2.customFeildName] = `exelAnswer${this.dataCustomFeildName.length}`
              }
            })
          }
        })
        this.export_data.forEach((item1) => {
          if (item1.regisCustomFeild) {
            item1.regisCustomFeild.forEach((item2) => {
              let index2 = this.dataCustomFeildName.findIndex(
                (a) => a === item2.customFeildName
              )
              item1[`exelAnswer${index2 + 1}`] = item2.value
            })
          }
        })
      }
      return this.export_data
    },
    async fetchExportData () {
      if (!this.serverMode) {
        return this.export_data || []
      }
      try {
        const res = await axios.get(
          this.DNS_IP + '/member/Member?shopId=' + this.session.data.shopId
        )
        const rows = Array.isArray(res.data) ? res.data : []
        return this.buildExportData(rows)
      } catch (error) {
        console.log('fetchExportData error', error)
        this.$swal('ผิดพลาด', 'ดึงข้อมูลสำหรับ Export ไม่สำเร็จ', 'error')
        return []
      }
    },
    async searchDataAll () {
      var search = '?name=' + this.searchAll + '&shopId=' + this.searchAll
      this.dataReady = false
      this.searchDataAllGlobal(
        this.DNS_IP,
        this.path,
        search,
        this.session.data.shopId,
        this.returnLink
      )
    },
    async getExportData () {
      console.log(this.session.data.shopId)
      await axios
        .get(
          'http://localhost:5001/get-history-activity/get?shopId=' +
            this.session.data.shopId
        )
        .then(async (response) => {
          console.log(response.data)
          this.export_data1 = response.data
        })
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    Export_LineUserId () {
      axios
        .get(
          this.DNS_IP + '/member/Member_Ex?shopId=' + this.session.data.shopId
        )
        .then(async (response) => {
          console.log(response.data)
          this.export_data1 = response.data
        })
    },
    async saerchDataAdvanced () {
      var search = ''
      var check = false

      for (var key in this.search) {
        check = true
        if (this.search[key]) {
          if (search !== '') {
            search += '&'
          }
          search += key + '=' + this.search[key]
        }

        if (
          this.search.last_date_start === '' &&
          this.search.last_date_end !== ''
        ) {
          check = false
          this.$swal('ผิดพลาด', 'กรุณาเลือกวันที่แก้ไข เริ่มต้น', 'error')
        }

        if (
          this.search.create_date_start === '' &&
          this.search.create_date_end !== ''
        ) {
          check = false
          this.$swal('ผิดพลาด', 'กรุณาเลือกวันที่สร้าง เริ่มต้น', 'error')
        }
      }
      if (check === true) {
        this.dataReady = false

        this.saerchDataAdvancedGlobal(
          this.DNS_IP,
          this.path,
          search,
          this.session.data.shopId,
          this.returnLink
        )
      } else {
        this.dataReady = true
      }
    },
    async getDataById (item) {
      this.id = item.memberId
      console.log('item', this.id)
      this.fromUpdate.name = item.name
      this.fromUpdate.point = item.point
      this.fromUpdate.level = item.level
      this.fromUpdate.picture = item.picture
      this.fromUpdate.tel = item.tel
      this.fromUpdate.birthDay = item.birthDay
      // this.getDataImg(item.memberId)
      let rs = await axios.get(
        this.DNS_IP +
          '/get-member-activity/get?lineUserId=' +
          item.liffUserId +
          '&shopId=' +
          this.session.data.shopId
      )
      this.memberActivity = rs.data
      console.log('ddddd', this.memberActivity)
    },
    async clearData () {
      for (var key in this.search) {
        if (this.search[key]) {
          this.search[key] = ''
        }
      }
    },
    chooseImage () {
      this.$refs.fileInputA.click()
    },
    async onSelectFile () {
      const input = this.$refs.fileInputA
      this.filesAdd = input.files
      const _this = this
      let params = new FormData()
      params.append('file', this.filesAdd[0])
      console.log('file', params.append('file', this.filesAdd[0]))
      if (this.filesAdd) {
        await axios
          .post(this.DNS_IP + `/file/upload/blog`, params)
          .then(async function (response) {
            console.log('aa')
            _this.formupdateA.pictureA = response.data
            console.log('url Pic', _this.formupdateA.pictureA)
          })
        console.log('เข้า', this.formupdateA.pictureA)
        var dt = {
          before_img: this.formupdateA.pictureA
        }
        await axios
          .post(this.DNS_IP + '/member/edit/' + this.id, dt)
          .then((res) => {
            this.$swal({
              title: 'อัปโหลดภาพ',
              text: 'สำเร็จ',
              type: 'success',
              timer: 2000,
              showConfirmButton: false
            })
            console.log('rs')
          })
        this.formupdateA.pictureUrlPreviewA = URL.createObjectURL(
          this.filesAdd[0]
        )
      } else {
        this.formupdateA.pictureUrlPreviewA = ''
      }
      this.$forceUpdate()
    },
    chooseImageB () {
      this.$refs.fileInputB.click()
      console.log('s')
    },
    async onSelectFileB () {
      const input = this.$refs.fileInputB
      this.filesAddB = input.files
      const _this = this
      let params = new FormData()
      params.append('file', this.filesAddB[0])
      console.log('file', params.append('file', this.filesAddB[0]))
      if (this.filesAddB) {
        await axios
          .post(this.DNS_IP + `/file/upload/blog`, params)
          .then(async function (response) {
            console.log('aa')
            _this.formupdateB.pictureB = response.data
            console.log('url Pic', _this.formupdateB.pictureB)
          })
        console.log('เข้า', this.formupdateB.pictureB)
        var dt = {
          after_img: this.formupdateB.pictureB
        }
        await axios
          .post(this.DNS_IP + '/member/edit/' + this.id, dt)
          .then((res) => {
            this.$swal({
              title: 'อัปโหลดภาพ',
              text: 'สำเร็จ',
              type: 'success',
              timer: 2000,
              showConfirmButton: false
            })
            console.log('rs')
          })
        this.formupdateB.pictureUrlPreviewB = URL.createObjectURL(
          this.filesAddB[0]
        )
      } else {
        this.formupdateB.pictureUrlPreviewB = ''
      }
      this.$forceUpdate()
    },
    getDataImg (i) {
      axios
        .get(this.DNS_IP + '/member/getID?memberId=' + i.memberId)
        .then((res) => {
          this.formupdateA.pictureA = res.data.before_img
          this.formupdateA.pictureUrlPreviewA = res.data.before_img
          this.formupdateB.pictureB = res.data.after_img
          this.formupdateB.pictureUrlPreviewB = res.data.after_img
        })
    },
    personalData (item) {
      this.personalLoaded = {
        tel: item.tel,
        surname: item.nameCustomer,
        birthday: item.birthDay,
        email: item.email
      }
      this.personal.name = item.name
      this.personal.imgProfile = item.picture
      this.personal.surname = item.nameCustomer
      this.personal.levelName = item.LevelName
      this.personal.gender = item.gender
      this.personal.tel = item.tel
      this.personal.birthday = item.birthDay
      this.personal.createDate = item.CREATE_DATE
      this.personal.coupon = item.coupon
      this.personal.memberId = item.memberId
      this.personal.email = item.email
      this.personal.pictureUrlLevel = item.pictureUrlLevel
      this.personal.collectPoint = item.collectPoint
      this.personal.currentPoint = item.currentPoint
      this.personal.remark = item.remark
      this.personal.regisCustomFeild = item.regisCustomFeild
      if (item.gender === 'ผู้ชาย') {
        this.personal.icon = 'mdi-gender-male'
      } else if (item.gender === 'ผู้หญิง') {
        this.personal.icon = 'mdi-gender-female'
      } else {
        this.personal.icon = 'mdi-gender-transgender'
      }

      this.showTabel = false
      this.getExpirySchedule(item)
    },
    async getExpirySchedule (item) {
      this.expirySchedule = null
      try {
        // รายชื่อจาก /member/Member ไม่มี memberCardId ติดมา (มีเฉพาะตอนค้นหา) จึงหาจาก memberId
        let memberCardId = item.memberCardId
        if (!memberCardId && item.memberId) {
          const card = await axios.get(this.DNS_IP + '/memberCard/get', {
            params: { memberId: item.memberId, shopId: this.session.data.shopId }
          })
          if (Array.isArray(card.data) && card.data.length > 0) {
            memberCardId = card.data[0].memberCardId
          }
        }
        if (!memberCardId) return
        const res = await axios.get(this.DNS_IP + '/memberCard/expiry-schedule', {
          params: { memberCardId: memberCardId, shopId: this.session.data.shopId }
        })
        // กันคำตอบของสมาชิกคนก่อนมาทับ เมื่อแอดมินกดเปลี่ยนคนเร็ว ๆ
        if (res.data.status === true && this.personal.memberId === item.memberId) {
          this.expirySchedule = res.data
        }
      } catch (error) {
        console.log(error)
      }
    },
    thaiDate (ymd) {
      return moment(ymd, 'YYYY-MM-DD').add(543, 'years').format('DD/MM/YYYY')
    },
    exportExcel () {
      var data = []
      var dataFinal = {}
      let pushDataFinal = []

      this.dataItem.map((el) => {
        data.push(el)
      })
      console.log('DATA', data)
      if (
        this.$session.getAll().data.shopId ===
          'U97dd281445cde30a599a5f5515a4e937' ||
        this.$session.getAll().data.shopId ===
          'U60f3a4215c86a978d5f6191292ad0109'
      ) {
        data.map((resule) => {
          // console.log('resule.IdbarCodeMember', resule.IdbarCodeMember)
          dataFinal = {
            linUserId: resule.liffUserId,
            barCodeId: resule.IdbarCodeMember,
            ชื่อไลน์: resule.name,
            ชื่อ: resule.nameCustomer,
            เพศ: resule.gender,
            เบอร์โทรศัพท์: resule.tel,
            คะแนนที่ได้รับ: resule.collectPoint,
            คะแนนที่ถูกใช้: resule.redeemPoint,
            คะแนนคงเหลือ: resule.currentPoint,
            คะแนนที่จะถูกตัดเดือนนี้: resule.balancePoint,
            วันเกิด: resule.birthDay,
            ระดับ: resule.LevelName,
            วันที่สมัครสมาชิก: resule.CREATE_DATE
          }
          pushDataFinal.push(dataFinal)
        })
      } else {
        data.map((resule) => {
          // console.log('resule.IdbarCodeMember', resule.IdbarCodeMember)
          dataFinal = {
            linUserId: resule.liffUserId,
            ชื่อไลน์: resule.name,
            ชื่อ: resule.nameCustomer,
            เพศ: resule.gender,
            เบอร์โทรศัพท์: resule.tel,
            คะแนนที่ได้รับ: resule.collectPoint,
            คะแนนที่ถูกใช้: resule.redeemPoint,
            คะแนนคงเหลือ: resule.currentPoint,
            คะแนนที่จะถูกตัดเดือนนี้: resule.balancePoint,
            วันเกิด: resule.birthDay,
            ระดับ: resule.LevelName,
            วันที่สมัครสมาชิก: resule.CREATE_DATE
          }
          pushDataFinal.push(dataFinal)
        })
      }
      console.log('pushDataFinal', pushDataFinal)
      // const dataWS = XLSX.utils.json_to_sheet(pushDataFinal)
      // const wb = XLSX.utils.book_new()
      // XLSX.utils.book_append_sheet(wb, dataWS)
      // XLSX.writeFile(wb, 'ข้อมูลรายชื่อลูกค้า.xlsx')
    },
    async getDataHis (item) {
      // console.log('aqaq', item)
      this.Onemonth = true
      this.packageButton = false
      this.Threemonth = false
      this.Sixmonth = false
      this.Oneyear = false
      const currentDate = new Date()
      const year = currentDate.getFullYear()
      const month = String(currentDate.getMonth() + 1).padStart(2, '0') // การใส่เลขเดือนต้องเพิ่ม 1 เพราะเดือนเริ่มที่ 0
      const day = String(currentDate.getDate()).padStart(2, '0') // การใส่วันต้องใช้ padStart เพื่อเติม 0 หน้าเลขถ้าเป็นตัวเลขเดียว

      const formattedDate = `${year}/${month}/${day}`
      console.log('formattedDate', formattedDate)
      await axios
        .get(
          this.DNS_IP +
            '/history?shopId=' +
            this.session.data.shopId +
            '&memberId=' +
            item.memberId +
            '&date=' +
            formattedDate
        )
        .then((res) => {
          this.desserts = res.data.data
          this.desserts.map((el) => {
            if (el.redeemStatus === 'get') {
              el.redeemStatus = 'รอรับของ'
            } else if (el.redeemStatus === 'use') {
              el.redeemStatus = 'รับของสำเร็จ'
            }
          })
        })
      await axios
        .get(
          this.DNS_IP + '/notify/get?shopId=' +
          this.session.data.shopId +
            '&memberId=' + this.memberId + '&date=' +
            formattedDate + '&name=รายการรับคะแนน วันเกิด'
        )
        .then(async (response) => {
          if (Array.isArray(response.data)) {
            response.data.forEach((item) => {
              this.desserts.push({'date': item.CREATE_DATE, 'productExchangeRateName': item.name, 'point': item.details.split(' ')[1], 'amount': null, 'file_data': null})
            })
          }
          console.log('formfffff', this.desserts)
        })
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
      await axios
        .get(
          this.DNS_IP + '/notify/get?shopId=' +
          this.session.data.shopId +
            '&memberId=' + this.memberId + '&date=' +
            formattedDate + '&name=รายการรับคะแนนจากกิจกรรม Friend get Friend'
        )
        .then(async (response) => {
          if (Array.isArray(response.data)) {
            response.data.forEach((item) => {
              this.desserts.push({'date': item.CREATE_DATE, 'productExchangeRateName': item.name, 'point': item.details.split(' ')[1], 'amount': null, 'file_data': null})
            })
          }
          console.log('form', this.desserts)
        })
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
      await axios
        .get(
          this.DNS_IP + '/Log_SpecialPoint/get?shopId=' +
            this.session.data.shopId +
              '&memberId=' + this.memberId + '&date=' +
            formattedDate
        )
        .then(async (response) => {
          if (Array.isArray(response.data)) {
            console.log('form', response.data)
            this.desserts.push({'date': response.data[0].CREATE_DATE, 'productExchangeRateName': response.data[0].type_specialPoint, 'point': response.data[0].point, 'amount': null, 'file_data': null})
          }
          console.log('form', this.desserts)
        })
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
      await axios
        .get(
          this.DNS_IP + '/activityLog/get?shopId=' +
          this.session.data.shopId +
            '&memberId=' +
            this.memberId + '&date=' +
            formattedDate
        )
        .then(async (response) => {
          if (Array.isArray(response.data)) {
            // this.formUpdate = response.data
            this.datacheck = []
            console.log('response.data', response.data)
            response.data.forEach((item) => {
              if (item.bvpBillingNumber !== '' && item.bvpBillingNumber) {
                if (this.datacheck.some((dataItem) => dataItem.bvpBillingNumber === item.bvpBillingNumber)) {
                  this.datacheck.forEach((item2) => {
                    let { bvpBillingNumber } = item2
                    if (bvpBillingNumber === item.bvpBillingNumber) {
                      item2.point += parseInt(item.coin)
                    }
                  })
                } else {
                  this.datacheck.push({'productExchangeRateName': 'แบบสอบถาม เลขบิล: ' + item.bvpBillingNumber, 'point': parseInt(item.coin), 'bvpBillingNumber': item.bvpBillingNumber, 'date': item.CREATE_DATE})
                  console.log('this.datacheck', this.datacheck)
                }
              } else {
                this.desserts.push({'date': item.CREATE_DATE, 'productExchangeRateName': 'กิจกรรม:' + item.title, 'point': item.coin, 'amount': null, 'file_data': null})
              }
            })
          }
          this.datacheck.forEach((item) => {
            this.desserts.push(item)
          })
        })
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
      if (Array.isArray(this.desserts)) {
        this.desserts = this.desserts.sort((a, b) => new Date(b.date) - new Date(a.date))
        console.log('gogog', this.desserts)
      }
    },
    async searchHistory (months) {
      this.loading2 = true
      this.packageButton = false
      this.Onemonth = months === 1
      this.Threemonth = months === 3
      this.Sixmonth = months === 6
      this.Oneyear = months === 12
      try {
        const res = await axios.get(
          this.DNS_IP +
          '/member/history/combined?shopId=' + this.session.data.shopId +
          '&memberId=' + this.memberId +
          '&months=' + months
        )
        const rows = (res.data && res.data.data) || []
        rows.forEach((el) => {
          if (el.redeemStatus === 'get') el.redeemStatus = 'รอรับของ'
          else if (el.redeemStatus === 'use') el.redeemStatus = 'รับของสำเร็จ'
        })
        this.desserts = rows
      } catch (err) {
        console.log('searchHistory error', err)
        this.desserts = []
        this.dataReady = true
      }
      this.loading2 = false
    },
    Search_1month () { return this.searchHistory(1) },
    Search_3month () { return this.searchHistory(3) },
    Search_6month () { return this.searchHistory(6) },
    Search_1year () { return this.searchHistory(12) },
    addMemberId (item) {
      this.memberId = item.memberId
    },
    async editTel () {
      var id = this.memberId
      const phoneSplit = this.personal.tel.split('-')
      const newPhone = phoneSplit.join('')
      // ไม่ได้แก้อะไร ก็ไม่ต้องเขียนทับ -- ถ้าเบอร์ถูกปิดบังอยู่ ค่าที่ส่งกลับไป
      // จะเป็นเบอร์ที่ขาดหายไปครึ่งหนึ่ง
      if (this.sameMemberTel(this.personalLoaded.tel, newPhone)) {
        this.editDataTel = true
        return
      }
      const data = {
        tel: newPhone
      }
      axios.post(this.DNS_IP + '/member/edit/' + id, data).then((res) => {
        console.log('res', res.data)
        this.editDataTel = true
      })
    },
    async editRemark () {
      var id = this.memberId
      const remark = this.personal.remark.replace(/'/g, "\\'")
      const data = {
        remark: remark
      }
      axios.post(this.DNS_IP + '/member/edit/' + id, data).then((res) => {
        console.log('res', res.data)
        this.editDataRemark = true
      })
    },
    async editEmailfunc () {
      var id = this.memberId
      const email = this.personal.email.replace(/'/g, "\\'")
      const data = {
        email: email
      }
      axios.post(this.DNS_IP + '/member/edit/' + id, data).then((res) => {
        console.log('res', res.data)
        this.editEmail = true
      })
    },
    async editNameCustomer () {
      var id = this.memberId
      const name = this.personal.surname.replace(/'/g, "\\'")
      const data = {
        nameCustomer: name
      }
      axios.post(this.DNS_IP + '/member/edit/' + id, data).then((res) => {
        console.log('res', res.data)
        this.editDataNameCustomer = true
      })
    },
    async editBirthDate () {
      var id = this.memberId
      const date = this.personal.birthday
      const data = {
        birthDay: date
      }
      console.log(data)
      axios.post(this.DNS_IP + '/member/edit/' + id, data).then((res) => {
        console.log('res', res.data)
        this.editDataBirthDate = true
      })
    },
    async changExpirePackage () {
      this.$swal({
        title: 'ต้องการ เปลี่ยนวันหมดอายุ ใช่หรือไม่?',
        text: 'เปลี่ยนเป็นวันที่ ' + this.pickerChangeExpire,
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          console.log('result', result)
          const timestamp = new Date(this.pickerChangeExpire).getTime() / 1000
          console.log(timestamp)
          console.log(this.dataPackage.idPackageLog)
          try {
            const url1 =
              this.DNS_IP +
              '/PackageLog/update/' +
              this.dataPackage.idPackageLog
            let dt1 = {
              expirePackage: timestamp
            }
            await axios.post(url1, dt1).then(async (response) => {
              if (response.data.status === true) {
                this.$swal({
                  title: 'เรียบร้อย',
                  type: 'success',
                  showCancelButton: false,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#b3b1ab',
                  confirmButtonText: 'ตกลง'
                })
                  .then(async (result) => {
                    console.log(result)
                    this.dialogChangeExpire = false
                    await this.getPackage()
                  })
                  .catch((error) => {
                    console.log(error)
                  })
              } else {
                this.$swal('ผิดพลาด', response.data.message, 'error')
                this.$router.push('/Master/Package')
                location.reload()
              }
            })
          } catch (error) {
            console.log('errir', error)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    },

    async filterData () {
      this.serverMode = false
      this.tableOptions.page = 1
      this.filter = []
      if (this.date1.length > 0 && this.date1.length === 2) {
        this.date1.sort()
        const startDate = moment(this.date1[0]).format('MM-DD')
        const endDate = moment(this.date1[1]).format('MM-DD')
        console.log('df')
        this.filter.push(
          `birthDay=${encodeURIComponent(`${startDate} ${endDate}`)}`
        )
        this.menu = false
      } else if (this.date1.length === 1) {
        const startDate = moment(this.date1[0]).format('MM-DD')
        const endDate = moment(this.date1[0]).format('MM-DD')
        console.log('endDate', endDate)
        this.filter.push(
          `birthDay=${encodeURIComponent(`${startDate} ${endDate}`)}`
        )
        this.menu = false
      }
      if (this.searchlevel) {
        this.filter.push(
          `levelId=${encodeURIComponent(`${this.searchlevel}`)}`
        )
      }
      if (this.searchGender) {
        this.filter.push(
          `Gender=${encodeURIComponent(`${this.searchGender}`)}`
        )
      }
      if (this.searchTel) {
        this.searchTel.split('-').join('').trim()
        // if (this.searchTel.length === 10) {
        this.filter.push(
          `tel=${encodeURIComponent(`${this.searchTel}`)}`
        )
        // } else {

        // }
      }
      let queryString = this.filter.join('&')
      console.log(this.DNS_IP + '/member/Member?shopId=' + this.session.data.shopId + '&' + queryString)
      await axios
        .get(this.DNS_IP + '/member/get?shopId=' + this.session.data.shopId + '&' + queryString)
        .then(async (response) => {
          if (response.data.length > 0) {
            this.dataReady = true
            this.dataItem = response.data
            console.log('this.dataItem ===>', this.dataItem)
            this.dataItem.map((el) => {
              if (el.gender === 'male') {
                el.gender = 'ผู้ชาย'
              } else if (el.gender === 'female') {
                el.gender = 'ผู้หญิง'
              } else if (el.gender === 'lgbt') {
                el.gender = 'เพศทางเลือก'
              }
              el.age = this.calculateAge(el.birthDay)
            })
          } else {
            // this.$swal('ผิดพลาด', 'ไม่มีข้อมูล2', 'error')
            this.dataReady = true
            this.dataItem = []
          }
          this.export_data = response.data
          this.export_data.map((item) => {
            if (item.regisCustomFeild !== null) {
              item.regisCustomFeild = JSON.parse(item.regisCustomFeild)
            }
            if (item.birthDay !== '') {
              item.birthDay = moment(item.birthDay)
                .add(543, 'years')
                .format('DD/MM/YYYY')
            } else {
              item.birthDay = ''
            }
            if (item.CREATE_DATE !== '') {
              item.CREATE_DATE = moment(item.CREATE_DATE)
                .add(543, 'years')
                .format('DD/MM/YYYY')
            } else {
              item.CREATE_DATE = ''
            }
          })
          let index = null
          index = this.export_data.findIndex(
            (a) => a.regisCustomFeild !== null
          )
          this.dataCustomFeildName = []
          if (index !== null) {
            this.export_data.forEach((item, index) => {
              if (item.regisCustomFeild) {
                item.regisCustomFeild.forEach((item2, index) => {
                  let findData = this.dataCustomFeildName.includes(
                    item2.customFeildName
                  )
                  if (!findData) {
                    this.dataCustomFeildName.push(item2.customFeildName)
                    const keyName2 = `${item2.customFeildName}`
                    this.export_field[keyName2] = `exelAnswer${this.dataCustomFeildName.length}`
                  }
                })
              }
            })
            this.export_data.map((item1) => {
              if (item1.regisCustomFeild) {
                item1.regisCustomFeild.forEach((item2, index) => {
                  console.log('item2.value', index)
                  let index2 = this.dataCustomFeildName.findIndex(
                    (a) => a === item2.customFeildName
                  )
                  const keyName1 = `exelAnswer${index2 + 1}`
                  item1[keyName1] = item2.value
                })
              }
            })
            console.log('this.export_data', this.export_data)
          }
        })
        .catch((error) => {
          console.log(error)
          //   this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
          this.dataReady = true
        })
      console.log('queryString', queryString)
    },
    getLevel () {
      this.dataLevel = []
      axios
        .get(
          this.DNS_IP + '/level/get?shopId=' + this.session.data.shopId
        )
        .then((res) => {
          let rs = res.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.levelId
            s.text = d.name
            d = s
            this.dataLevel.push(d)
          }
          this.dataLevel.push({
            text: 'ทั้งหมด',
            value: '',
            levelId: ''
          })
          console.log('ddwwww', this.dataLevel)
        })
    },
    getGender () {
      this.dataExchange = []
      axios
        .get(
          this.DNS_IP +
            '/member-gender?shopId=' +
            this.session.data.shopId
        )
        .then((res) => {
          let rs = res.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            if (d.gender === 'female') {
              d.genderText = 'ผู้หญิง'
            } else if (d.gender === 'male') {
              d.genderText = 'ผู้ชาย'
            }
            s.value = d.gender
            s.text = d.genderText
            d = s
            this.dataExchange.push(d)
          }
          this.dataExchange.push({
            text: 'ทั้งหมด',
            value: '',
            levelId: ''
          })
        })
    },
    resetSearch () {
      this.date1 = []
      this.searchlevel = ''
      this.searchGender = ''
      this.searchTel = ''
    },
    clearTextField () {
      this.date = []
      this.getDataList()
    }

  }
}
</script>
<style scope>
/* body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow-x: hidden;
  overflow: hidden;
} */

.v-simple-checkbox .v-icon {
  cursor: pointer !important;
  color: rgb(41, 39, 39) !important;
}

.v-breadcrumbs {
  padding: 0px 12px !important;
}

.image-input {
  display: block;
  width: 230px;
  height: 230px;
  /* min-width: 300px;
  min-height: 300px; */
  cursor: pointer;
  background-size: cover;
  background-position: center center;
}

.center {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/System/ListMember.vue